var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "24px",
    viewBox: "0 0 30.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,4174 L0,4174 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37818938,0 L9.37818938,1.87488187 L20.6255906,1.87488187 L20.6255906,0 L26.2502363,0 L26.2502363,1.87488187 L30,1.87488187 L30,22.5004725 L0,22.5004725 L0,1.87488187 L3.75165375,1.87488187 L3.75165375,0 L9.37818938,0 Z M28.1251181,3.74976375 L1.87488187,3.74976375 L1.87488187,20.6274806 L28.1251181,20.6274806 L28.1251181,3.74976375 Z M24.3753544,5.62464562 L24.3753544,7.4995275 L26.2502363,7.4995275 L26.2502363,9.37440937 L24.3753544,9.37440937 L24.3753544,11.2511813 L22.5023625,11.2511813 L22.5023625,9.37440937 L20.6255906,9.37440937 L20.6255906,7.4995275 L22.5023625,7.4995275 L22.5023625,5.62464562 L24.3753544,5.62464562 Z M9.37440937,7.4995275 L9.37440937,9.37440937 L3.74787375,9.37440937 L3.74787375,7.4995275 L9.37440937,7.4995275 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-778.0 -2207.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.0 2083.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(677.0 120.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.0 4.749763749764162)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 30,0 30,22.5004725 0,22.5004725 0,0",
    stroke: "none",
    fill: "#00095B"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryHealth);
export default __webpack_public_path__ + "static/media/BatteryHealth.6d34467315fbc5b4e8e724934c05c3d2.svg";
export { ForwardRef as ReactComponent };